import { Box, Pagination, Typography } from 'components/ui';
import { FormattedMessage } from 'react-intl';
import { useQuery } from '@apollo/client/react';
import { DividerContainer } from 'components/styles_components/container';
import { useError } from 'contexts/error';
import { usePaginate } from 'contexts/paginate';
import InfoContainer from 'components/info_container';
import SpaceOrdersQuery from 'queries/space/orders';
import Index from 'components/space/order/index';
import { WhiteCard } from 'components/styles_components/card';

const IndexContainer = () => {
  const { page, onPageChange } = usePaginate();
  const setError = useError();
  const {
    data = { spaceOrders: { spaceOrders: [], perPage: 10 } },
    loading,
  } = useQuery(SpaceOrdersQuery, {
    variables: {
      page: page,
    },
    cachePolicy: 'no-cache',
    onError: () => {
      setError('error.space.orders.index');
    },
  });

  return (
    <WhiteCard>
      <Typography variant="h5">
        <FormattedMessage id="space.orders" />
      </Typography>
      <InfoContainer visible={!loading && data.spaceOrders.spaceOrdersTotal === 0}>
        <FormattedMessage id="empty.space.orders.title.short" />
      </InfoContainer>
      <Index
        loading={loading}
        orders={data.spaceOrders.spaceOrders}
      />
      <Box display="flex" justifyContent="center">
        {data.spaceOrders.spaceOrdersTotalPages > 1 && (
          <Pagination
            count={data.spaceOrders.spaceOrdersTotalPages}
            page={page}
            onChange={(_e, nextPage) => {
              onPageChange(nextPage);
            }}
          />
        )}
      </Box>
      <DividerContainer />
    </WhiteCard>
  );
};

export default IndexContainer;
